import { Component, ViewChild, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import {
    ScriptLoaderService
} from './../../../../../_services';
import { Unit, Investor, Property } from './../../../../../_models';
import { LiveSearchSelectComponent } from './../../../../../shared/live-search-select';
import { UnitTableComponent } from '../unit-table';

@Component({
    selector: 'app-unit-list',
    templateUrl: './unit-list.component.html',
    styleUrls: ['./unit-list.component.scss']
})
export class UnitListComponent implements OnInit {
    name: string;
    poolFilter: string = "Todas";
    searchString: string;
    sort: any = {};
    currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
    areaInPoolFrom: number;
    areaInPoolTo: number;
    mottoValueInPoolFrom: number;
    mottoValueInPoolTo: number;
    totalInPoolRentas: number;
    totalInPoolArea: number;
    totalInPoolMottoValue: number;
    @ViewChild('investorFilter') investorFilter: LiveSearchSelectComponent;
    @ViewChild('propertyFilter') propertyFilter: LiveSearchSelectComponent;
    private unitTable: UnitTableComponent;
    @ViewChild(UnitTableComponent) set content(content: UnitTableComponent) {
        this.unitTable = content;
        this.unitTable.getData(`include=investor,property`).subscribe(units => { });
    }
    listContainer = {
        newEntry: {
            link: '/units/new',
            text: 'Nueva unidad'
        }
    };
    propertyTexts = {
        label: "Propiedad",
        notFound: "Propiedad no encontrada",
        loading: "Cargando propiedades...",
        none: "Ninguna propiedad"
    };
    investorTexts = {
        label: "Propietario",
        notFound: "Propietario no encontrado",
        loading: "Cargando propietarios...",
        none: "Ningun propietario"
    };
    constructor(
        private _domSanitizer: DomSanitizer,
        private _script: ScriptLoaderService,
        private unitData: Unit,
        private investorData: Investor,
        private propertyData: Property
    ) {
        this.investorData.sanitizer = _domSanitizer;
        this.unitData.sanitizer = _domSanitizer;
    }

    ngOnInit() {
        this.unitData.getSummary().subscribe(response => {
            this.totalInPoolRentas = response.data.in_pool;
            this.totalInPoolArea = response.data.all_total_area_pool;
            this.totalInPoolMottoValue = response.data.all_motto_value_pool;
        });
    }

    search() {
        if (this.unitTable) this.unitTable.getData(this.searchString).subscribe(units => {
            if (units.length > 0) {
                this.totalInPoolRentas = units[0].summary.in_pool;
                this.totalInPoolArea = units[0].summary.all_total_area_pool;
                this.totalInPoolMottoValue = units[0].summary.all_motto_value_pool;
            } else {
                this.totalInPoolRentas = 0;
                this.totalInPoolArea = 0;
                this.totalInPoolMottoValue = 0;
            }
        });
    }

    clear() {
        this.name = '';
        this.investorData.make({});
        this.propertyData.make({});
        this.investorFilter.clear();
        this.propertyFilter.clear();
        this.poolFilter = "Todas";
        this.areaInPoolFrom = null;
        this.areaInPoolTo = null;
        this.mottoValueInPoolFrom = null;
        this.mottoValueInPoolTo = null;
        if (this.unitTable) this.unitTable.getData(`include=investor,property`).subscribe(units => { });
    }

    buildSearchString(name) {
        let result = ``;
        if (name) {
            result += `name=${name}`;
        }
        if (!this.investorData.empty()) {
            result += `&investor_id=${this.investorData.item.id}`;
        }
        if (!this.propertyData.empty()) {
            result += `&property_id=${this.propertyData.item.id}`;
        }
        if (this.poolFilter == 'Dentro de pool') {
            result += `&in_pool=1`;
        }
        if (this.poolFilter == 'Fuera de pool') {
            result += `&in_pool=0`;
        }
        if (this.sort.dir && this.sort.column) {
            result += `&sortDir=${this.sort.dir}&sortBy=${this.sort.column}`;
        }
        if (this.areaInPoolFrom) {
            result += `&areaInPoolFrom=${this.areaInPoolFrom}`;
        }
        if (this.areaInPoolTo) {
            result += `&areaInPoolTo=${this.areaInPoolTo}`;
        }
        if (this.mottoValueInPoolFrom) {
            result += `&mottoValueInPoolFrom=${this.mottoValueInPoolFrom}`;
        }
        if (this.mottoValueInPoolTo) {
            result += `&mottoValueInPoolTo=${this.mottoValueInPoolTo}`;
        }
        result += `&include=investor,property`;
        this.searchString = result;
    }
    changeInvestorFilter(investor) {
        this.investorData.item = investor;
        this.buildSearchString(this.name);
    }
    changePropertyFilter(property) {
        this.propertyData.item = property;
        this.buildSearchString(this.name);
    }
    changePoolFilter(pool) {
        this.poolFilter = pool;
        this.buildSearchString(this.name);
    }
    onSort(data) {
        this.sort = data;
        this.buildSearchString(this.name);
        this.search();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/units/unit-list/unit-list.component.ts